function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpouse = function SvgSpouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182.35 165.57"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M54 62.35a31.18 31.18 0 1 0-31.17-31.18A31.29 31.29 0 0 0 54 62.35Zm0-7.61a23.57 23.57 0 1 1 23.5-23.57A23.57 23.57 0 0 1 54 54.74Z",
    style: {
      fill: "#ad112b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.23 157.94H7.63v-43.86A46.22 46.22 0 0 1 86.35 81a8.13 8.13 0 0 1 3.44-.73H96a53.94 53.94 0 0 0-96 33.81v51.49h107.94v-9.29h-7.71Z",
    style: {
      fill: "#ad112b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.27 122.52a1.37 1.37 0 0 1 2.37 1v24.6a8.11 8.11 0 0 1-8.14 8.14H92.79a8.11 8.11 0 0 1-8.14-8.14V88.43a8.09 8.09 0 0 1 8.14-8.14h46.48a1.19 1.19 0 0 1 1.18.85 1.3 1.3 0 0 1-.33 1.52l-5.43 5.43a1.15 1.15 0 0 1-.85.34h-41v59.71h59.66V128.8a1.15 1.15 0 0 1 .34-.85Zm-23.41 15.78-15.27 1.7a7.07 7.07 0 0 1-7.8-7.8l1.69-15.26 44.62-44.62a10 10 0 0 1 14.07 0l7.3 7.29a10 10 0 0 1 0 14.08Zm18-49.19-31.55 31.55-1.19 11 11-1.18L162.68 99Zm13.57-11a1.85 1.85 0 0 0-2.55 0l-5.26 5.26 9.84 9.84 5.26-5.26a1.84 1.84 0 0 0 0-2.54Z",
    style: {
      fill: "#ad112b"
    }
  }));
};
export default SvgSpouse;